import { Input } from "@mantine/core";
import { RichTextEditor } from "@mantine/tiptap";
import { useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";
import { useEffect } from "react";

// Boş editörün gövde yüksekliği. tiptap'ın placeholder'ı `height: 0` bir ::before olarak
// basılıyor, yani kutuyu BÜYÜTMÜYOR: uzun bir placeholder tek satırlık boş editörün altından
// taşıyordu. Çeviri alanlarında placeholder kaynak metnin kendisi (bir-iki cümle), dolayısıyla
// taşma kural hâline gelmişti.
//
// Sabit bir alt sınır, dolu olan taban alanıyla boş çeviri alanını da aynı boyda tutuyor.
const MIN_BODY_HEIGHT = 120;

export function RichTextField({ label, value, onChange, placeholder }) {
  const editor = useEditor({
    extensions: [
      StarterKit,
      Placeholder.configure({ placeholder: placeholder ?? "" }),
    ],
    content: value ?? "",
    onUpdate: ({ editor }) => onChange?.(editor.getHTML()),
  });

  useEffect(() => {
    if (editor && value !== undefined && value !== editor.getHTML()) {
      editor.commands.setContent(value ?? "", { emitUpdate: false });
    }
  }, [value, editor]);

  return (
    <Input.Wrapper label={label}>
      <RichTextEditor editor={editor} mt={4}>
        <RichTextEditor.Toolbar sticky stickyOffset={0}>
          <RichTextEditor.ControlsGroup>
            <RichTextEditor.Bold />
            <RichTextEditor.Italic />
            <RichTextEditor.Underline />
            <RichTextEditor.Strikethrough />
          </RichTextEditor.ControlsGroup>
          <RichTextEditor.ControlsGroup>
            <RichTextEditor.H2 />
            <RichTextEditor.H3 />
          </RichTextEditor.ControlsGroup>
          <RichTextEditor.ControlsGroup>
            <RichTextEditor.BulletList />
            <RichTextEditor.OrderedList />
          </RichTextEditor.ControlsGroup>
          <RichTextEditor.ControlsGroup>
            <RichTextEditor.Link />
            <RichTextEditor.Unlink />
          </RichTextEditor.ControlsGroup>
        </RichTextEditor.Toolbar>
        <RichTextEditor.Content style={{ minHeight: MIN_BODY_HEIGHT }} />
      </RichTextEditor>
    </Input.Wrapper>
  );
}
